module.exports = __webpack_public_path__ + "img/dropdown-search-cjdr.323c0268.png";